import AppRecord from './AppRecord.js'

class Reporting extends AppRecord {
  constructor(rec){
    super(rec)
  }
}

export default Reporting

